import { CampaignType } from 'types/campaign'
import { Action, Dispatch } from 'redux'
import { confirmCampaignAction } from 'reducks/campaign/actions'
import { push } from 'connected-react-router'

const confirmCampaign = (campaign: CampaignType) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(confirmCampaignAction(campaign))
    dispatch(push('/admin/campaign_cms/confirm'))
  }
}

export default confirmCampaign
